module.exports = __webpack_public_path__ + "img/10.66ba3495.jpg";